import { InvitationTypes } from '../shared/invitation-types';

export interface RespondentModel {
  id: string | null;
  participantId: string | null;
  groupId: string;
  groupIndex: number;
  firstName: string;
  lastName: string;
  emailAddress: string;
  avatar: string;
  percentageComplete: number;
  status: number;
  locale: string;
  languageId: number;
  isValid: boolean;
  isSet: boolean;
  errorMessage: string;
  personalMessage: string;
  isValidatingEmailAddress: boolean;
  isSaving: boolean;
  isSendingReminder: boolean;
  isExpanded: boolean;
  lastEmailSentDate: string | null;
  invitationType: InvitationTypes;
  canResendEmail: boolean;
  isBusy?: boolean;
}
